// extracted by mini-css-extract-plugin
export default {"root":"AppPage_root__ZWkNc","header":"AppPage_header__FL7Te","title":"AppPage_title__+s8vn","subtitle":"AppPage_subtitle__xepqd"};